export interface ServiceDetailData {
  id: string;
  title: string;
  icon: string;
  description: string;
  fullContent: string;
  benefits: string[];
  process: { title: string; desc: string }[];
  accentColor: string;
  image: string;
}

export const serviceDetails: Record<string, ServiceDetailData> = {
  'batteriewechsel': {
    id: 'batteriewechsel',
    title: 'Batteriewechsel',
    icon: 'fa-battery-full',
    description: 'Austausch der Batterie für verbesserte Leistung und längere Akkulaufzeit.',
    fullContent: 'Hält Ihr Smartphone nicht mehr den ganzen Tag durch? Schaltet es sich bei Kälte unerwartet aus? Ein professioneller Batteriewechsel bei TendoTec gibt Ihrem Gerät die ursprüngliche Leistung zurück. Wir verwenden ausschließlich zertifizierte Akkuzellen mit originaler Kapazität.',
    benefits: [
      'Originalgetreue Kapazität',
      'Installation in unter 60 Minuten',
      'Kalibrierung des Ladezyklus',
      '6 Monate Garantie auf die neue Zelle'
    ],
    process: [
      { title: 'Diagnose', desc: 'Wir messen den aktuellen Gesundheitszustand Ihres Akkus.' },
      { title: 'Sicherer Ausbau', desc: 'Fachgerechte Entfernung des alten, verklebten Akkus.' },
      { title: 'Reinigung', desc: 'Entfernung von Kleberesten und Staub im Gehäuse.' },
      { title: 'Einbau & Test', desc: 'Installation des neuen Akkus und Funktionskontrolle.' }
    ],
    accentColor: '#10b981',
    image: '/images/service_overview.png'
  },
  'softwareaktualisierung': {
    id: 'softwareaktualisierung',
    title: 'Softwareaktualisierung',
    icon: 'fa-arrows-rotate',
    description: 'Regelmäßige Updates, um die neuesten Funktionen und Sicherheitsverbesserungen zu gewährleisten.',
    fullContent: 'Software-Probleme können Ihr Gerät verlangsamen oder Sicherheitslücken öffnen. Wir helfen Ihnen bei der Installation der neuesten Betriebssystem-Versionen, beheben Boot-Loops und optimieren die Systemperformance für ein reibungsloses Erlebnis.',
    benefits: [
      'Behebung von Systemfehlern',
      'Maximale Sicherheitsupdates',
      'Optimierte Akkulaufzeit durch Software',
      'Backup-Sicherung inklusive'
    ],
    process: [
      { title: 'Analyse', desc: 'Überprüfung der aktuellen Software-Version und Fehlerprotokolle.' },
      { title: 'Datensicherung', desc: 'Sicherung Ihrer wichtigen Daten vor dem Update.' },
      { title: 'Installation', desc: 'Aufspielen der neuesten, stabilen Firmware.' },
      { title: 'Setup', desc: 'Konfiguration des Systems für optimale Leistung.' }
    ],
    accentColor: '#3b82f6',
    image: '/images/advanced_repair.png'
  },
  'displayreparatur': {
    id: 'displayreparatur',
    title: 'Displayreparatur',
    icon: 'fa-mobile-screen',
    description: 'Behebung von Displayproblemen wie Rissen oder Pixelfehlern.',
    fullContent: 'Ein gesprungenes Display beeinträchtigt nicht nur die Optik, sondern kann auch die Elektronik darunter gefährden. Ob Glasbruch, Pixelfehler oder Touch-Probleme – wir tauschen Ihre Display-Einheit schnell und präzise aus.',
    benefits: [
      'Brillante Farbwiedergabe',
      'Perfekte Touch-Reaktion',
      'Staubdichte Verklebung',
      'TrueTone-Übertragung (bei iPhones)'
    ],
    process: [
      { title: 'Demontage', desc: 'Vorsichtiges Öffnen des Geräts unter Hitzeeinwirkung.' },
      { title: 'Entkernung', desc: 'Übertragung von Sensoren und Kameras auf das neue Display.' },
      { title: 'Versiegelung', desc: 'Erneuerung der wasserabweisenden Klebedichtung.' },
      { title: 'Kalibrierung', desc: 'Anpassung von Helligkeit und Farben an den Standard.' }
    ],
    accentColor: '#ef4444',
    image: '/images/hero.png'
  },
  'festplattenbereinigung': {
    id: 'festplattenbereinigung',
    title: 'Festplattenbereinigung',
    icon: 'fa-database',
    description: 'Optimierung des Speicherplatzes für eine reibungslose Leistung.',
    fullContent: 'Ein voller Speicher macht jeden Computer langsam. Wir analysieren Ihre Datenstruktur, entfernen unnötigen Ballast und optimieren Ihr Dateisystem, damit Sie wieder flüssig arbeiten können – ohne Datenverlust.',
    benefits: [
      'Schnellere Boot-Zeiten',
      'Mehr freier Speicherplatz',
      'Sicheres Löschen von Datenmüll',
      'Defragmentierung und Indexierung'
    ],
    process: [
      { title: 'Scan', desc: 'Identifikation von großen Dateien und System-Müll.' },
      { title: 'Rücksprache', desc: 'Sie entscheiden, welche privaten Daten entfernt werden.' },
      { title: 'Bereinigung', desc: 'Tiefenreinigung des Betriebssystems und der Registry.' },
      { title: 'Beschleunigung', desc: 'Optimierung der Start-Up Prozesse.' }
    ],
    accentColor: '#8b5cf6',
    image: '/images/service_overview.png'
  },
  'tastaturreparatur': {
    id: 'tastaturreparatur',
    title: 'Tastaturreparatur',
    icon: 'fa-keyboard',
    description: 'Behebung von Tastaturproblemen, einschließlich defekter Tasten.',
    fullContent: 'Klemmende Tasten oder ein kompletter Ausfall der Tastatur machen das Arbeiten unmöglich. Wir tauschen einzelne Tastenmechaniken aus oder ersetzen die komplette Tastatureinheit bei Laptops sämtlicher Marken.',
    benefits: [
      'Wiederherstellung des Druckpunkts',
      'Originale Layouts verfügbar',
      'Reinigung unter den Tasten',
      'Funktionale Hintergrundbeleuchtung'
    ],
    process: [
      { title: 'Tasten-Check', desc: 'Prüfung jedes einzelnen Kontakts auf Fehlfunktion.' },
      { title: 'Reinigung', desc: 'Ultraschall-Reinigung bei verklebten Tasten.' },
      { title: 'Ersatz', desc: 'Fachgerechter Tausch der Switch-Einheiten.' },
      { title: 'Testlauf', desc: 'Schreibtest zur Sicherstellung der Reaktionszeit.' }
    ],
    accentColor: '#f59e0b',
    image: '/images/advanced_repair.png'
  },
  'luefterreinigung': {
    id: 'luefterreinigung',
    title: 'Lüfterreinigung',
    icon: 'fa-wind',
    description: 'Reinigung der Lüftungsschlitze für optimale Kühlung.',
    fullContent: 'Hitzestau ist der größte Feind Ihrer Hardware. Wenn Ihr Laptop laut wird oder heiß läuft, ist oft eine verstaubte Kühlung schuld. Wir reinigen das Kühlsystem und erneuern die Wärmeleitpaste für maximale Lebensdauer.',
    benefits: [
      'Geringere Betriebstemperatur',
      'Lautloser Betrieb des Geräts',
      'Verhinderung von Hardware-Schäden',
      'Maximale CPU/GPU Leistung'
    ],
    process: [
      { title: 'Öffnung', desc: 'Zugriff auf das interne Kühlsystem des Laptops.' },
      { title: 'Entstaubung', desc: 'Druckluft-Reinigung der Kühlrippen und Lüfter.' },
      { title: 'Paste-Update', desc: 'Erneuerung der hochwertigen Wärmeleitpaste.' },
      { title: 'Stresstest', desc: 'Überprüfung der Temperatur unter Volllast.' }
    ],
    accentColor: '#06b6d4',
    image: '/images/hero_vienna.png'
  },
  'datensicherung': {
    id: 'datensicherung',
    title: 'Datensicherung',
    icon: 'fa-hard-drive',
    description: 'Sichere Kopie wichtiger Daten, um Verluste zu vermeiden.',
    fullContent: 'Ihre Fotos, Dokumente und Kontakte sind unersetzlich. Wir erstellen für Sie ein professionelles Backup-Konzept oder sichern Ihre Daten einmalig auf externe Medien oder in die Cloud, damit Sie beruhigt sein können.',
    benefits: [
      '100% Diskretion Ihrer Daten',
      'Sicherung auf Cloud oder HDD',
      'Strukturierte Dateiorganisation',
      'Wiederherstellungsgarantie'
    ],
    process: [
      { title: 'Volumen-Check', desc: 'Ermittlung der zu sichernden Datenmenge.' },
      { title: 'Medium-Wahl', desc: 'Auswahl des passenden Speichermediums.' },
      { title: 'Transfer', desc: 'Verschlüsselter Datentransfer mit Integritätscheck.' },
      { title: 'Verifizierung', desc: 'Abschlussprüfung der Lesbarkeit des Backups.' }
    ],
    accentColor: '#ec4899',
    image: '/images/storefront.png'
  },
  'fluessigkeitsschaden': {
    id: 'fluessigkeitsschaden',
    title: 'Flüssigkeitsschaden',
    icon: 'fa-droplet',
    description: 'Reparatur nach Kontakt mit Wasser oder anderen Flüssigkeiten.',
    fullContent: 'Kaffee im Laptop oder Handy im Wasser? Handeln Sie schnell! Wir führen professionelle Ultraschallreinigungen der Platinen durch und entfernen Korrosion, bevor Folgeschäden entstehen.',
    benefits: [
      'Erhöhte Rettungschancen',
      'Platinen-Tiefenreinigung',
      'Korrosionsentfernung',
      'Detaillierter Schadensbericht'
    ],
    process: [
      { title: 'Sofort-Trocknung', desc: 'Entfernung restlicher Flüssigkeit im Vakuum.' },
      { title: 'Ultraschallbad', desc: 'Reinigung der Logikboards in speziellem Isopropanol.' },
      { title: 'Mikroskopie', desc: 'Suche nach korrodierten Bauteilen unter dem Mikroskop.' },
      { title: 'Instandsetzung', desc: 'Tausch betroffener SMD-Komponenten.' }
    ],
    accentColor: '#6366f1',
    image: '/images/advanced_repair.png'
  }
};
